import { render, staticRenderFns } from "./TransactionConfirm.vue?vue&type=template&id=7d4a6a7d&scoped=true"
import script from "./TransactionConfirm.vue?vue&type=script&lang=js"
export * from "./TransactionConfirm.vue?vue&type=script&lang=js"
import style0 from "./TransactionConfirm.vue?vue&type=style&index=0&id=7d4a6a7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4a6a7d",
  null
  
)

export default component.exports